"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

var FlowTemplatesApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(FlowTemplatesApi, _BasicDataHubApi);

  function FlowTemplatesApi() {
    (0, _classCallCheck2.default)(this, FlowTemplatesApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FlowTemplatesApi).apply(this, arguments));
  }

  (0, _createClass2.default)(FlowTemplatesApi, [{
    key: "copyToBot",
    value: function () {
      var _copyToBot = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(flowId, botId, shouldUpdateSteps) {
        var binding;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getBinding();

              case 2:
                binding = _context.sent;
                return _context.abrupt("return", binding.mutation.downloadTo({
                  entity: _constants.FLOW,
                  data: {
                    id: flowId,
                    body: {
                      botId: botId,
                      shouldUpdateSteps: shouldUpdateSteps
                    }
                  }
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function copyToBot(_x, _x2, _x3) {
        return _copyToBot.apply(this, arguments);
      }

      return copyToBot;
    }()
  }, {
    key: "getFlowTemplates",
    value: function () {
      var _getFlowTemplates = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref) {
        var _ref$query, query, projection;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref$query = _ref.query, query = _ref$query === void 0 ? {} : _ref$query, projection = _ref.projection;
                return _context2.abrupt("return", this._getPaginatedList('listTemplates', {
                  entity: _constants.FLOW,
                  params: {
                    queryParams: query
                  },
                  sourceId: query.sourceId,
                  forceSandbox: false
                }, projection));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFlowTemplates(_x4) {
        return _getFlowTemplates.apply(this, arguments);
      }

      return getFlowTemplates;
    }()
  }, {
    key: "getFlowTemplateById",
    value: function () {
      var _getFlowTemplateById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(id) {
        var binding;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getBinding();

              case 2:
                binding = _context3.sent;
                return _context3.abrupt("return", binding.query.getTemplate({
                  entity: _constants.FLOW,
                  params: {
                    id: id
                  },
                  sourceId: undefined
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getFlowTemplateById(_x5) {
        return _getFlowTemplateById.apply(this, arguments);
      }

      return getFlowTemplateById;
    }()
  }, {
    key: "getFlowTemplatesByToken",
    value: function () {
      var _getFlowTemplatesByToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref2) {
        var _ref2$query, query, projection, limit, token, binding;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, projection = _ref2.projection, limit = _ref2.limit, token = _ref2.token;
                _context4.next = 3;
                return this.getBinding();

              case 3:
                binding = _context4.sent;
                return _context4.abrupt("return", binding.query.listTemplates({
                  entity: _constants.FLOW,
                  params: {
                    queryParams: query,
                    limit: limit,
                    last: token
                  },
                  sourceId: query.sourceId,
                  forceSandbox: false
                }, projection || ['records', 'last']));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFlowTemplatesByToken(_x6) {
        return _getFlowTemplatesByToken.apply(this, arguments);
      }

      return getFlowTemplatesByToken;
    }()
  }, {
    key: "getFlowTemplatesByBotId",
    value: function getFlowTemplatesByBotId(botId, _ref3) {
      var projection = _ref3.projection;
      return this.getFlowTemplates({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }]);
  return FlowTemplatesApi;
}(_basic_data_hub_api.default);

var _default = FlowTemplatesApi;
exports.default = _default;